import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IDeleteSAMLConfigurationParams {
  idpConfigurationId: string;
}

export class DeleteSAMLConfigurationRequest extends Request<IDeleteSAMLConfigurationParams, IResult> {
  constructor(idpConfigurationId: IDeleteSAMLConfigurationParams){
    super('deleteSiteSAMLConfiguration', idpConfigurationId);
  }
}